import { ImageUtils } from '../../utils/image-utils';
import { StringUtils } from '../../utils/string-utils';
import { Graphic } from './graphic';
import { Dimension, Location, Rectangle, Resizable } from './meme.types';


export interface ObjectLocation {
    x: number;
    y: number;
    z: number;
    width: number;
}
export const CLIP_ART = 'ClipArt';
/**
 * Text of a meme that reside in a canvas
 */
export class FloatingGraphic extends Graphic implements Resizable {
    TYPE = CLIP_ART;

    id: string;
    private objectLocation: ObjectLocation;
    boundingRectangle: Rectangle;
    editPanelShown = false;
    topOffset = 5;

    constructor(location: ObjectLocation, initialSize: Dimension) {
        super();
        this.objectLocation = location;
        this.boundingRectangle = {
            x: location.x,
            y: location.y,
            width: initialSize.width,
            height: initialSize.height,
        };
        this.id = 'x-' + StringUtils.uuid();
    }

    getElementRect(): Rectangle {
        const el = document.getElementById(this.id);
        const rect = el.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height,
            x: rect.left,
            y: rect.top,
        };
    }

    getType() {
        return this.TYPE;
    }

    resize(mouseLocation: Location) {
        const containerRect = this.getElementRect();
        this.objectLocation.width = mouseLocation.x - containerRect.x;
        this.objectLocation.width = this.objectLocation.width < 100 ? 100 : this.objectLocation.width;
    }

    move(location: Location) {
        this.objectLocation.x = location.x;
        this.objectLocation.y = location.y;
    }

    moveToView(viewBound: Dimension) {
        this.objectLocation.x = 0;
        this.objectLocation.y = 0;
    }

    rotate(location: Location) {
    }

    showEditPanel() {
        this.editPanelShown = true;
    }

    toggleEditPanel() {
        this.editPanelShown = !this.editPanelShown;
    }

    hideEditPanel() {
        this.editPanelShown = false;
    }

    getEditPanelState() {
        return this.editPanelShown;
    }

    getBoundingRect(): Rectangle {
        return this.boundingRectangle;
    }

    setBoundingRect(rect: Rectangle) {
        this.boundingRectangle = rect;
    }

    getLocation(): ObjectLocation {
        return this.objectLocation;
    }

    getTopOffset(): number {
        return this.topOffset;
    }
}

export class FloatingSVGGraphic extends FloatingGraphic {
    graphicSrc: string;
    graphic: any;
    private constructor(location: ObjectLocation, svgPath: HTMLImageElement) {
        super(location, {
            width: svgPath.width,
            height: svgPath.height,
        });
        this.boundingRectangle = {
            x: location.x,
            y: location.y,
            width: svgPath.width,
            height: svgPath.height,
        };
        this.graphic = svgPath;
        this.graphicSrc = svgPath.src;
        this.id = 'x-' + StringUtils.uuid();
    }

    static async createNew(location: ObjectLocation, imagePath: string) {
        const svgImage = await ImageUtils.createImageFromSVG(imagePath);
        location.width = 150; // svgImage.width;
        const graphic = new FloatingSVGGraphic(location, svgImage);
        return graphic;
    }

    getGraphic() {
        return this.graphic;
    }

    getGraphicSrc() {
        return this.graphicSrc;
    }
}
